const style = (theme) => {
  const output = {
    parallaxRoot: {
      position: 'relative',
      zIndex: 1,
      extend: theme.wrapper,
      marginTop: 200,
      marginBottom: 200,
    },
    parallaxText: {
      position: 'relative',
      zIndex: 2,
      textAlign: 'left',
      lineHeight: 1,
      fontFamily: theme.fonts[1],
      fontSize: '10vw',
      pointerEvents: 'none',
      '& p': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    parallaxImg: {
      position: 'absolute',
      width: '18vw',
      height: 'auto',
      display: 'none',
      '&.parallax-img-1': {
        zIndex: 1,
        left: '2vw',
        top: '30%',
      },
      '&.parallax-img-2': {
        zIndex: 3,
        right: '20vw',
        top: '40%',
        width: '20vw',
      },
      '&.parallax-img-3': {
        zIndex: 1,
        right: '9vw',
        top: '45%',
      },
      '&.parallax-img-4': {
        zIndex: 1,
        left: '10vw',
        top: '60%',
      },
      '&.parallax-img-5': {
        zIndex: 3,
        left: '30vw',
        top: '70%',
      },
    },
    parallaxVirtual: {
      '& $parallaxText': {
        paddingTop: '130vh',
        paddingBottom: '120vh',
      },
      '& $parallaxImg': {
        display: 'block',
      },
    },
    cta: {
      fontFamily: theme.fonts[0],
      pointerEvents: 'all',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    parallaxText: {
      fontSize: '10vw',
    },
    parallaxImg: {
      width: '30vw',
      '&.parallax-img-2': {
        width: '40vw',
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    parallaxRoot: {
      marginTop: 100,
      marginBottom: 100,
    },
    parallaxText: {
      fontSize: '12vw',
    },
  }

  return output
}

export default style
